import { observer } from 'mobx-react-lite';
import { ReactElement, useContext, useEffect } from 'react';
import { Route } from 'react-router';
import { useOnMount } from '../../../common/hooks/useOnMount';
import { Settings } from '../../../modules/settings/SettingsContext';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { Datasets } from '../../modules/datasets/datasets.context';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { CreateDatasetView } from '../../views/home/datasets/Create.view';
import { DatasetsListView } from '../../views/home/datasets/List.view';
import { DatasetDetailsView } from '../../views/home/datasetsDetails/DatasetDetails.view';
import { Home } from '../config/Home';

export const DatasetsRoute = observer((): ReactElement => {
  const settingsContext = useContext(Settings);
  const context = useContext(Datasets);

  useEffect(() => {
    return (): void => {
      context.service.dispose();
    };
  }, []);

  useOnMount(() => {
    context.service.init(settingsContext.store.datasetsPageSize);
  });

  return (
    <SwitchWithNotFound notFound={<NotFoundView />}>
      <Route path={Home.Datasets.List.Path}>
        <DatasetsListView />
      </Route>
      <Route path={Home.Datasets.Create.Path}>
        <CreateDatasetView />
      </Route>
      <Route path={Home.Datasets.Details.Path}>
        <DatasetDetailsView />
      </Route>
    </SwitchWithNotFound>
  );
});
